export var LEDGER_SNAPSHOT = "LEDGER_SNAPSHOT";
export var LEDGER_DETAIL = "LEDGER_DETAIL";
export var LEDGER_DETAIL_FILTER = "LEDGER_DETAIL_FILTER";
export var LEDGER_DETAIL_SORT = "LEDGER_DETAIL_SORT";
export var LEDGER_DETAIL_SORT_CLEAR = "LEDGER_DETAIL_SORT_CLEAR";
export var LEDGER_SNAPSHOT_EXTENTION = "LEDGER_SNAPSHOT_EXTENTION";
export var LEDGER_CONTRACT_NOTE = "LEDGER_CONTRACT_NOTE";
